jQuery($ => {
  class AreasServedForm {
    constructor(element) {
      this._ = element;
      this._element = $(element);
      this._form = this._element.find('.m-areas-served-form__form');
      this._success = $('.o-areas-served-form-block__success');
      this._error = $('.o-areas-served-form-block__error');
      this._input = this._element.find('.m-field__input');

      this.init();
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Initialize
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    init() {
      this.setupHandlers();
      this._element.trigger('init', this);
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup Handlers
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    setupHandlers() {
      this._form.on('submit', (e) => this.handleFormSubmit(e));
    }

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Handle Form Submit
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    handleFormSubmit = (e) => {
      e.preventDefault();

      if (this._input.val() === '' || this._input.val().length < 5) {
        this._element.addClass('m-areas-served-form--error');
        this._element.find('.m-areas-served-form__error').show();
        return;
      } else {
        this._element.removeClass('m-areas-served-form--error');
        this._element.find('.m-areas-served-form__error').hide();
      }

      $.ajax({
        url: AJAX.url,
        type: 'POST',
        data: {
          action: 'handle_zipcode',
          nonce: AJAX.nonce,
          zipcode: this._input.val(),
        },
        beforeSend: () => {
          this._element.addClass('m-areas-served-form--loading');
        },
        success: (response) => {
          console.log(response);
          if (response.data === 'success') {
            this._element.closest('.o-areas-served-form-block').addClass('o-areas-served-form-block--success');
            this._element.closest('.o-areas-served-form-block').removeClass('o-areas-served-form-block--error');
          } else if (response.data === 'error') {
            this._element.closest('.o-areas-served-form-block').addClass('o-areas-served-form-block--error');
            this._element.closest('.o-areas-served-form-block').removeClass('o-areas-served-form-block--success');
          }
        },
        complete: () => {
          this._element.removeClass('m-areas-served-form--loading');
        },
        error: (response) => {
          console.log(response);
          this._error.show();
          this._success.hide();
        }
      })

    }
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Setup jQuery Plugin
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $.fn.areas_served_form = function () {
    var _ = this,
      opt = arguments[0],
      args = Array.prototype.slice.call(arguments, 1),
      l = _.length,
      i,
      ret;
    for (i = 0; i < l; i++) {
      if (typeof opt == 'object' || typeof opt == 'undefined')
        _[i].areas_served_form = new AreasServedForm(_[i], opt);
      else
        ret = _[i].areas_served_form[opt].apply(_[i].areas_served_form, args);
      if (typeof ret != 'undefined') return ret;
    }
    return _;
  }

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Run
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $('.m-areas-served-form').areas_served_form();
});